export const calculatorConfig = {
  budgetDefault: "$5,000",
  contractDefault: "$12,000",
  budgetSlider: { min: 0, max: 50000, step: 100 },
  contractSlider: { min: 0, max: 100000, step: 500 },
}
